<script lang="ts">
// Mostly copied from https://gist.github.com/Jonarod/7ff2fe4f81aae39e431aa7a08ce815bc

import { defineComponent, computed } from "vue";

export default defineComponent({
  props: {
    modelValue: [
      Boolean,
      String,
      Number,
      Array as () => Array<string | number>,
    ],
    value: [String, Number, Array as () => Array<string>, Boolean],
    trueValue: {
      type: [Boolean, String, Number],
      default: true,
    },
    falseValue: {
      type: [Boolean, String, Number],
      default: false,
    },
    checked: Boolean,
    id: String,
    name: String,
    round: Boolean,
    disabled: Boolean,
    indeterminate: Boolean,
  },
  emits: ["update:modelValue", "change"],
  setup: (props, { emit }) => {
    const computedValue = computed({
      get(): boolean | string | number | (string | number)[] | undefined {
        return props.checked || props.modelValue || props.value;
      },
      set(value: boolean | string | number | (string | number)[] | undefined) {
        emit("update:modelValue", value);
        emit("change", value);
      },
    });
    return { computedValue };
  },
});
</script>

<template>
  <div>
    <input
      :id="id"
      v-model="computedValue"
      type="checkbox"
      :name="name"
      :disabled="disabled"
      :indeterminate="indeterminate"
      :true-value="trueValue"
      :false-value="falseValue"
      :value="value"
      :checked="checked"
    />
    <span class="checkmark"></span>
  </div>
</template>

<style scoped>
div {
  display: inline-block;
  position: relative;
  bottom: -2px;
  width: 15px;
  height: 15px;
}
input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  box-shadow: inset 0 2px 10px rgba(1, 27, 38, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 5px;
}

input ~ .checkmark {
  backdrop-filter: blur(20px);
}

input:checked ~ .checkmark {
  background: #30add4;
  border: 1px solid #30add4;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

input:checked ~ .checkmark:after {
  display: block;
}

.checkmark:after {
  left: 4px;
  top: 2px;
  width: 5px;
  height: 8px;
  box-sizing: border-box;
  border: solid white;
  border-width: 0 2px 2px 0;
  border-radius: 2px;
  transform: rotate(45deg);
}
</style>
